// .pen: yDv2v/sq4nz (Selfie · Ritual · Dívidas · default|vazio)
import { CheckCircle, CreditCard } from '@phosphor-icons/react';

import { computeEntryDelta, formatDecimalForInput } from '../../../lib/selfieDisplayUtils';
import pt from '../../../locales/pt';
import { SelfieBalanceRow } from './SelfieBalanceRow';

// .pen: "Selfie · Ritual · Dívidas · default|vazio" › copy + lista/vazio
// title/subtitle: override para o modo edição (.pen: pbg46 "Corrigir dívidas de {month}")
export function SelfieDebtsStep({
  liabilities = [],
  liabilityEntries = {},
  previousLiabilityEntries = {},
  onLiabilityEntriesChange,
  title,
  subtitle,
}) {
  const copy = pt.snapshots.ritual.debts;

  const updateLiability = (id, patch) => {
    onLiabilityEntriesChange?.({
      ...liabilityEntries,
      [id]: { ...liabilityEntries[id], ...patch },
    });
  };

  const resetLiability = (liability) => {
    const previous = previousLiabilityEntries[liability.id];
    if (!previous) return;
    updateLiability(liability.id, {
      remaining_balance_eur: formatDecimalForInput(previous.remaining_balance_eur),
    });
  };

  return (
    <div className="flex flex-col gap-space-5">
      <div className="flex flex-col gap-space-2">
        <h1 className="font-display text-type-title-page font-semibold leading-[1.25] tracking-tight text-foreground">
          {title || copy.title}
        </h1>
        <p className="text-type-body leading-[1.55] text-muted-foreground">
          {subtitle || copy.subtitle}
        </p>
      </div>

      {liabilities.length === 0 ? (
        <div
          data-ds-id="ds/selfie/debts-empty"
          className="flex flex-col items-center gap-space-3 rounded-ds-lg border border-border bg-muted px-space-5 py-space-8 text-center"
        >
          <span className="relative flex size-24 items-center justify-center" aria-hidden>
            <span className="absolute inset-0 rounded-ds-full bg-sage-glow-soft blur-[10px]" />
            <span className="relative flex size-14 items-center justify-center rounded-ds-full bg-sage-tint">
              <CheckCircle className="size-[26px] text-sage-on-tint" aria-hidden />
            </span>
          </span>
          <p className="type-title-card font-semibold text-card-foreground">{copy.emptyTitle}</p>
          <p className="text-type-body-sm leading-[1.5] text-muted-foreground">{copy.emptyBody}</p>
        </div>
      ) : (
        <div className="flex flex-col gap-space-2-5">
          {liabilities.map((liability) => {
            const previous = previousLiabilityEntries[liability.id];
            const entry = liabilityEntries[liability.id] || {};
            const before =
              previous?.remaining_balance_eur !== undefined &&
              previous?.remaining_balance_eur !== null
                ? Number(previous.remaining_balance_eur)
                : null;
            const delta = computeEntryDelta(entry.remaining_balance_eur, before);

            return (
              <SelfieBalanceRow
                key={liability.id}
                icon={CreditCard}
                tone="warning"
                name={liability.name}
                beforeAmount={before}
                value={entry.remaining_balance_eur ?? ''}
                onChange={(event) =>
                  updateLiability(liability.id, {
                    remaining_balance_eur: event.target.value,
                  })
                }
                onReset={before != null ? () => resetLiability(liability) : undefined}
                delta={before != null ? delta : null}
                favorable={delta === null || delta <= 0}
                currencyPrefix="−€"
                ariaLabel={`${liability.name} saldo em dívida`}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SelfieDebtsStep;
